import { styled, Box as MuiBox, Stack as MuiStack } from "@mui/material";

export const Box = styled(MuiBox)(
  ({ theme }) => `
  &.mark-wrapper {
    position: absolute;  
    border: 1px solid ${theme.palette.primary["main"]};
    color: ${theme.palette.primary["main"]};
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    left: 12px;
    bottom: 50px;
    border-radius: 3px;
    padding: 2px 4px;
    display: flex;
    align-items: center;
    background: #ffffff;
    padding: 6px;
  }
  `
);

export const Stack = styled(MuiStack)``;
